
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11069_3895)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_11069_3895)"}},[_c('path',{attrs:{"d":"M12.164 1v.001a10.815 10.815 0 014.147.817l.487.216c1.124.53 2.15 1.25 3.03 2.131l.367.386A10.818 10.818 0 0123 11.828h-.002a10.837 10.837 0 01-3.178 7.83h.001a11.172 11.172 0 01-7.784 3.343l.001.001-.006-.001v.001-.001a10.707 10.707 0 01-7.77-3.104H4.26a11.04 11.04 0 01-3.24-7.168L1 12.188v-.003a11.095 11.095 0 013.175-7.862l.393-.382A11.093 11.093 0 0111.973 1h.191zM12 11.188a.21.21 0 00-.21.21v5.45a.212.212 0 00.21.21.211.211 0 00.212-.21v-5.45a.212.212 0 00-.212-.21zm-.016-4.267a.515.515 0 00.008 1.027h.026a.514.514 0 10-.01-1.027h-.024z","fill":"#D26404","stroke":"#FEFEFE","stroke-width":"2"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11069_3895"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_11069_3895"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    